module.exports = __webpack_public_path__ + "img/price-3-star.f6cf67de.png";